import Dashboard from './Dashboard'

export default Dashboard
// eslint-disable-next-line import/export
export * from './Dashboard'
